import { type FC, useId } from 'react';

import * as styles from './brand.css';
import { STREAMLAIN_CORE_LOGO } from './streamlain-logo-mark';

export interface StreamLainLogoMarkProps {
  idsPrefix?: string;
  animated?: boolean;
}

function normalizeSvgId(id: string) {
  return id.replace(/[^a-zA-Z0-9_-]/g, '');
}

export const StreamLainLogoMark: FC<StreamLainLogoMarkProps> = ({
  idsPrefix,
  animated = false,
}) => {
  const generatedId = useId();
  const safeIdsPrefix =
    idsPrefix ?? `streamlain-logo-${normalizeSvgId(generatedId)}`;
  const upperMaskId = `${safeIdsPrefix}-upper-mask`;
  const lowerMaskId = `${safeIdsPrefix}-lower-mask`;
  const renderPath = (layer: 'upper' | 'lower', maskId?: string) => {
    const source = STREAMLAIN_CORE_LOGO.mark[layer];
    return (
      <g mask={maskId ? `url(#${maskId})` : undefined}>
        <g transform={source.transform}>
          <path
            fill={`var(--sl-brand-mark-${layer}, ${layer === 'upper' ? STREAMLAIN_CORE_LOGO.colors.primary : STREAMLAIN_CORE_LOGO.colors.secondary})`}
            d={source.path}
          />
        </g>
      </g>
    );
  };

  return (
    <g className={styles.mark}>
      {animated ? (
        <defs>
          <mask
            id={upperMaskId}
            maskUnits="userSpaceOnUse"
            x="0"
            y="0"
            width={STREAMLAIN_CORE_LOGO.mark.width}
            height={STREAMLAIN_CORE_LOGO.mark.height}
          >
            <path
              className={styles.upperFlowReveal}
              d={STREAMLAIN_CORE_LOGO.loader.upperTrace}
              pathLength="100"
              fill="none"
              stroke="#fff"
              strokeWidth={STREAMLAIN_CORE_LOGO.loader.strokeWidth}
              strokeLinecap="round"
              strokeLinejoin="round"
            />
          </mask>
          <mask
            id={lowerMaskId}
            maskUnits="userSpaceOnUse"
            x="0"
            y="0"
            width={STREAMLAIN_CORE_LOGO.mark.width}
            height={STREAMLAIN_CORE_LOGO.mark.height}
          >
            <path
              className={styles.lowerFlowReveal}
              d={STREAMLAIN_CORE_LOGO.loader.lowerTrace}
              pathLength="100"
              fill="none"
              stroke="#fff"
              strokeWidth={STREAMLAIN_CORE_LOGO.loader.strokeWidth}
              strokeLinecap="round"
              strokeLinejoin="round"
            />
          </mask>
        </defs>
      ) : null}
      {renderPath('upper', animated ? upperMaskId : undefined)}
      {renderPath('lower', animated ? lowerMaskId : undefined)}
    </g>
  );
};
